import { defineMessages } from 'react-intl';

export default defineMessages({
  partners: {
    id: 'Unknown.PartnersScreen.partners',
    defaultMessage: 'Partners'
  },
  createPartner: {
    id: 'Unknown.PartnersScreen.createPartner',
    defaultMessage: 'Create Partner'
  },
  updatePartner: {
    id: 'Unknown.PartnersScreen.updatePartner',
    defaultMessage: 'Update Partner'
  },
  name: {
    id: 'Unknown.PartnersScreen.name',
    defaultMessage: 'Name'
  },
  generalPartner: {
    id: 'Unknown.PartnersScreen.generalPartner',
    defaultMessage: 'General Partner'
  },
  tenants: {
    id: 'Unknown.PartnersScreen.tenants',
    defaultMessage: 'Tenants'
  },
  actions: {
    id: 'Unknown.PartnersScreen.actions',
    defaultMessage: 'Actions'
  },
  update: {
    id: 'Unknown.PartnersScreen.update',
    defaultMessage: 'Update'
  },
  delete: {
    id: 'Unknown.PartnersScreen.delete',
    defaultMessage: 'Delete'
  },
  updateTenants: {
    id: 'Unknown.PartnersScreen.updateTenants',
    defaultMessage: 'Update Tenants'
  },
  noPartners: {
    id: 'Unknown.PartnersScreen.noPartners',
    defaultMessage: 'No partners found'
  },
  loading: {
    id: 'Unknown.PartnersScreen.loading',
    defaultMessage: 'Loading...'
  },
  yes: {
    id: 'Unknown.PartnersScreen.yes',
    defaultMessage: 'Yes'
  },
  no: {
    id: 'Unknown.PartnersScreen.no',
    defaultMessage: 'No'
  },
  type: {
    id: 'Unknown.PartnersScreen.type',
    defaultMessage: 'Type'
  },
  logoUrl: {
    id: 'Unknown.PartnersScreen.logoUrl',
    defaultMessage: 'Logo URL'
  },
  partnerUrl: {
    id: 'Unknown.PartnersScreen.partnerUrl',
    defaultMessage: 'Partner URL'
  },
  cancel: {
    id: 'Unknown.PartnersScreen.cancel',
    defaultMessage: 'Cancel'
  },
  save: {
    id: 'Unknown.PartnersScreen.save',
    defaultMessage: 'Save'
  },
  selectTenant: {
    id: 'Unknown.PartnersScreen.selectTenant',
    defaultMessage: 'Select Tenant'
  }
});
